import { Button, Modal } from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { formatMsisdn } from "../../../tools/tools";
import { clearFormData } from "../../../reducer/serviceReducer";
import { clearGlobalFormData } from "../../../reducer/serviceReducerGlobala";
import OprationResult from "../../auxiliary/opration/opration";
import ShopPage from "../../auxiliary/shop/ShopPage";
import "./esim.scss";

// receipt of an eSIM sale, from the RedirectToNeginWalletGateWay response; the QR code is never shown to the dealer
const EsimFinal = () => {
	const location = useLocation();
	const dispatch = useDispatch();
	const res = location?.state || {};
	const [open, setOpen] = useState(true);

	useEffect(() => {
		return () => {
			dispatch(clearFormData(["spPurchase"]));
			dispatch(clearGlobalFormData(["spPurchase"]));
		};
	}, [dispatch]);

	const list = [
		{ label: "نام باندل", value: res.bundleName },
		{ label: "شماره خریداری شده", value: <span dir="ltr">0{formatMsisdn(res.msisdn)}</span> },
		{ label: "تاریخ و زمان خرید", value: <span dir="ltr">{res.purchaseDate}</span> },
		{ label: "شماره کیت", value: <span dir="ltr">{res.kitNo}</span> },
		{ label: "کد پیگیری", value: <span dir="ltr">{res.followupcode}</span> },
	];

	return (
		<ShopPage
			title="فروش eSIM"
			prefix="sp"
			footer={
				<Button className="btn-normal btn-print" onClick={() => window.print()} type="default" icon={<i className="icon-print"></i>}>
					چاپ فاکتور
				</Button>
			}>
			<OprationResult isSucess={true} list={list} messageForSuccess={res.dealerNotice || ""} />
			<Modal
				open={open}
				onCancel={() => setOpen(false)}
				title={
					<div className="esim-success-head">
						<i className="icon-true"></i>
						<h3>{res.message || "خرید eSIM با موفقیت انجام شد"}</h3>
					</div>
				}
				centered
				footer={
					<Button className="btn-normal btn-aptel" type="primary" danger onClick={() => setOpen(false)}>
						متوجه شدم
					</Button>
				}>
				<ul className="esim-success-list">
					{list.slice(0, 4).map((item) => (
						<li key={item.label}>
							<span>{item.label}</span>
							<b>{item.value}</b>
						</li>
					))}
				</ul>
				{res.dealerNotice && <p className="esim-notice">{res.dealerNotice}</p>}
			</Modal>
		</ShopPage>
	);
};

export default EsimFinal;
